import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Hero from '../../../components/Hero';
import Features from '../../../components/Features';
import CTA from '../../../components/CTA';

const LandingPage = () => {
  const navigate = useNavigate();


  return (
    <>
      <Helmet>
        <title>Syntimacy</title>
      </Helmet>
      <>
        <main>
          <Hero />
          <Features />
          <CTA />
        </main>
      </>
    </>
  );
}

export default LandingPage;
